import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { defaulColumnVisibilityModel } from '../../../v2/components/generic/ObjectsDataTable/fns';
import { viewDefinitionToGridColumnMap } from '../../../v2/components/generic/transformFns';
import { GroupViewDefinition } from '../../SytemManagement/Devices/DeviceGatewayGroupViewSubParts';
import { StripedDataGrid } from '../DataGrid';
/**
 * Takes a list of items and displays them
 *
 * WARN: devoid of controls — if you need controls, use a Listerlizer
 *
 * If you need checkbox selection, consider `useFlexibleList()`
 */
export const SimpleList = (props) => {
    const { listItems, viewDefinition, ...dataGridPropsIn } = props;
    const columnMap = { ...viewDefinitionToGridColumnMap(viewDefinition ?? GroupViewDefinition, true) };
    const columns = useMemo(() => Object.entries(columnMap).map(([k, v]) => ({ field: k, ...v })), [columnMap, props.checkboxSelection]);
    const dataGridProps = {
        columns,
        columnVisibilityModel: defaulColumnVisibilityModel,
        rows: listItems,
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        density: 'compact',
        pageSizeOptions: [10],
        hideFooter: listItems.length <= 10,
        hideFooterPagination: listItems.length <= 10,
        checkboxSelection: false,
        initialState: { sorting: { sortModel: [{ field: 'name', sort: 'asc' }] }, pagination: { paginationModel: { pageSize: 10 } } },
        ...dataGridPropsIn,
    };
    return _jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, ...dataGridProps });
};
